<template>
  <v-container>
    <v-overlay :absolute="absolute" :value="overlay" z-index="1000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col>
        <v-banner elevation="1">Usuarios</v-banner>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="text-center">
          <v-text-field
            label="Buscar"
            placeholder="Usuario..."
            v-model="searchUser"
            @keyup="filterUsers()"
          ></v-text-field>
        </div>
      </v-col>
      <v-col>
        <div class="text-center float-right">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                fab
                small
                icon
                @click="showNew()"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>
                  mdi-account-plus
                </v-icon>
              </v-btn>
            </template>
            <span>Agregar Usuario</span>
          </v-tooltip>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-sheet elevation="1">
          <v-progress-linear
            indeterminate
            color="primary"
            v-if="loading"
          ></v-progress-linear>
          <v-simple-table cols="auto" elevation="9">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">
                    Email
                  </th>
                  <th class="text-center">
                    Nombre
                  </th>
                  <th class="text-center">
                    Tipo
                  </th>
                  <th class="text-center">
                    Opciones
                  </th>
                </tr>
              </thead>
              <template v-if="users.length">
                <tbody>
                  <tr class="text-center" v-for="user in users" :key="user.id">
                    <td>{{ user.id }}</td>
                    <td>{{ user.fullName }}</td>
                    <td>
                      <template v-if="user.isAdmin == true">
                        <v-chip class="ma-2" small color="primary">
                          Administrador
                        </v-chip>
                      </template>
                      <template v-else>
                        <v-chip class="ma-2" small color="primary">
                          Autorizado
                        </v-chip>
                      </template>
                    </td>
                    <td>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            fab
                            small
                            icon
                            @click="showEdit(user)"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon>
                              mdi-account-edit
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            fab
                            small
                            icon
                            @click="showDelete(user)"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon>
                              mdi-delete
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Eliminar</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </template>
              <template v-else>
                <div class="float-right pa-4">
                  No hay registros
                </div>
              </template>
            </template>
          </v-simple-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogDelete" scrollable max-width="420px">
      <v-card min-width="100%">
        <v-card-title>Eliminar Usuario</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          ¿está seguro que desea eliminar el usuario {{ userDelete.id }}?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="grey darken-1" text @click="dialogDelete = false">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="warning float-right"
            text
            @click="deleteUser(userDelete)"
          >
            Si
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogNew" scrollable max-width="420px">
      <v-card min-width="100%">
        <v-card-title>Crear Usuario:</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <v-form v-model="validNew">
            <v-container>
              <v-row>
                <v-col cols="12" class="px-8 pt-6">
                  <v-text-field
                    v-model="userNew.fullName"
                    :rules="nameRules"
                    :counter="24"
                    label="Nombre completo"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="px-8">
                  <v-text-field
                    v-model="userNew.id"
                    :rules="emailRules"
                    label="E-mail"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="px-8 pb-6">
                  <v-text-field
                    v-model="userNew.password"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="show ? 'text' : 'password'"
                    name="input-10-1"
                    label="Contraseña"
                    hint="Al menos 8 caracteres"
                    counter
                    autocomplete
                    @click:append="show = !show"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="px-8 pb-6">
                  <v-checkbox
                    v-model="userNew.isAdmin"
                    label="Administrador"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="grey darken-1" text @click="dialogNew = false">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary float-right"
            text
            @click="saveUserNew()"
            :disabled="!validNew"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogEdit" scrollable max-width="420px">
      <v-card min-width="100%">
        <v-card-title>Editar Usuario: {{ userEdit.id }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <v-form v-model="valid">
            <v-container>
              <v-row>
                <v-col cols="12" class="px-8 pt-6">
                  <v-text-field
                    v-model="userEdit.fullName"
                    :rules="nameRules"
                    :counter="24"
                    label="Nombre completo"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="px-8">
                  <v-text-field
                    v-model="userEdit.id"
                    :rules="emailRules"
                    label="E-mail - No puede modificar este campo"
                    required
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="px-8 pb-6">
                  <v-text-field
                    v-model="userEdit.password"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="show ? 'text' : 'password'"
                    name="input-10-1"
                    label="Contraseña"
                    hint="Al menos 8 caracteres"
                    counter
                    autocomplete
                    @click:append="show = !show"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="px-8 pb-6">
                  <v-checkbox
                    v-model="userEdit.isAdmin"
                    label="Administrador"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="grey darken-1" text @click="dialogEdit = false">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary float-right"
            text
            @click="saveUserEdit(userEdit)"
            :disabled="!valid"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="alertSnackbar" :timeout="3000" top>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="alertSnackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { Config } from "../config";
export default {
  data() {
    return {
      loading: false,
      overlay: true,
      absolute: true,
      userNew: {
        fullName: "",
        password: "",
        id: "",
        isAdmin: false
      },
      userDelete: {},
      dialogNew: false,
      validNew: false,
      alertSnackbar: false,
      snackbarText: "",
      users: [],
      dialogEdit: false,
      userEdit: {
        fullName: "",
        password: "",
        id: "",
        isAdmin: false
      },
      searchUser: "",
      valid: false,
      show: false,
      nameRules: [
        v => !!v || "El nombre no puede estar vacío",
        v => v.length >= 4 || "El nombre debe ser mayor a 4 caracteres",
        v => v.length <= 25 || "El nombre debe ser menor a 24 caracteres"
      ],
      emailRules: [
        v => !!v || "E-mail no puede estar vacío",
        v => /.+@.+/.test(v) || "E-mail no es válido"
      ],
      rules: {
        required: value => !!value || "Es necesario la contraseña.",
        min: v => v.length >= 8 || "Mínimo 8 caracteres",
        emailMatch: () => `E-mail y/o contraseña que introdujo no coinciden`
      },
      dialogDelete: false
    };
  },
  mounted() {
    this.getUsers();
  },
  computed: {},
  methods: {
    getUsers() {
      this.overlay = true;
      let url = Config.url + "/db/user";
      this.axios
        .get(url)
        .then(res => {
          this.users = res.data.users;
        })
        .catch(err => {
          console.log(err);
          this.snackbarText =
            "Error en servidor, falló al tratar de obtener lista de usuarios";
          this.alertSnackbar = true;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showEdit(userEdit) {
      this.userEdit.fullName = userEdit.fullName;
      this.userEdit.id = userEdit.id;
      this.userEdit.isAdmin = userEdit.isAdmin;
      this.userEdit.rev = userEdit.rev;
      this.dialogEdit = true;
    },
    showNew() {
      this.dialogNew = true;
    },
    showDelete(user) {
      this.dialogDelete = true;
      this.userDelete = user;
    },
    deleteUser(user) {
      this.overlay = true;
      this.dialogDelete = false;
      let url = Config.url + "/db/user";
      let params = {
        id: user.id,
        rev: user.rev
      };
      this.axios
        .delete(url, { params: params })
        .then(res => {
          if (res.status == 200) {
            this.snackbarText = "Usuario eliminado exitosamente";
            this.alertSnackbar = true;
            this.getUsers();
          }
        })
        .catch(err => {
          console.log(err);
          this.snackbarText =
            "Ocurrió un error al eliminar usuario, intente más tarde";
          this.alertSnackbar = true;
          this.getUsers();
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    saveUserNew() {
      this.overlay = true;
      this.dialogNew = false;
      let url = Config.url + "/db/user";
      let params = this.userNew;
      this.userNew.id = this.userNew.id.replace(/\s/g, "");
      this.axios
        .post(url, params)
        .then(res => {
          if (res.status == 201) {
            this.snackbarText = "Usuario guardado exitosamente";
            this.alertSnackbar = true;
            this.userNew = {
              fullName: "",
              password: "",
              id: "",
              isAdmin: false
            };
            this.getUsers();
          }
        })
        .catch(err => {
          if (err.response.status == 409) {
            this.snackbarText = `Usuario ${this.userNew.id} ya existe`;
          } else {
            this.snackbarText =
              "Ocurrió un error al guardar usuario, intente más tarde";
          }
          this.alertSnackbar = true;
          this.getUsers();
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    saveUserEdit(user) {
      this.overlay = true;
      this.dialogNew = false;
      this.snackbarText = "Usuario actualizado exitosamente";
      this.alertSnackbar = true;
      this.dialogEdit = false;
      user.id = user.id.replace(/\s/g, "");
      let params = {
        id: user.id,
        rev: user.rev,
        fullName: user.fullName,
        password: user.password,
        isAdmin: user.isAdmin
      };
      let url = Config.url + "/db/user";
      this.axios
        .put(url, params)
        .then(res => {
          if (res.status == 200) {
            this.snackbarText = "Usuario actualizado exitosamente";
            this.alertSnackbar = true;
          }
        })
        .catch(err => {
          console.log(err);
          if (err.response.status == 409) {
            this.snackbarText = `Usuario ${user.id} ya existe`;
          } else {
            this.snackbarText =
              "Ocurrió un error al actualizar usuario, intente más tarde";
          }
          this.alertSnackbar = true;
        })
        .finally(() => {
          this.overlay = false;
          this.getUsers();
        });
    },
    filterUsers() {
      this.loading = true;
      if (this.searchUser != "") {
        let url = Config.url + "/db/user";
        this.axios
          .get(url)
          .then(res => {
            this.users = res.data.users;
            let arrayFilterUsers = [];
            let searchUser = this.searchUser.toLowerCase();
            this.users.map(item => {
              let name = item.fullName.toLowerCase();
              let email = item.id.toLowerCase();
              if (
                name.search(searchUser) != -1 ||
                email.search(searchUser) != -1
              ) {
                arrayFilterUsers.push(item);
              }
            });
            this.users = arrayFilterUsers;
          })
          .catch(err => {
            console.log(err);
            this.snackbarText = "Ocurrió un error, intente más tarde";
            this.alertSnackbar = true;
          });
      } else {
        this.getUsers();
      }
      this.loading = false;
    }
  }
};
</script>

<style></style>
